import { NoteMultipleIcon } from './NoteMultipleIcon';

/**
 * author: Austin Andrews
 * id 0A0E42BA-FE9D-44C6-BF6A-D29D6013F2E0
 * name note-multiple
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-multiple.svg
 * tags
 */
export const StickyNotesIcon = NoteMultipleIcon;
export default StickyNotesIcon